module.exports = __webpack_public_path__ + "img/icon_5_51.9d3ab336.png";